import React from 'react';

import { Icon } from '@chakra-ui/react';

export const GCPModelArmorTemplateIcon = props => (
  <Icon viewBox="0 0 722 720" w="full" h="full" color="inherit" {...props}>
    <g transform="translate(-298 0)">
      <g>
        <g>
          <g>
            <path
              d="M722.063 721.583C729.225 725.318 732.808 727.185 737.774 728.149 741.648 728.904 747.23 728.904 751.103 728.149 756.069 727.185 759.652 725.318 766.814 721.583 833.054 687.072 1023.54 574.292 1023.54 418.655L1023.54 286.697C1023.54 258.803 1023.54 244.857 1018.98 232.869 1014.95 222.278 1008.4 212.828 999.896 205.336 990.274 196.855 977.216 191.958 951.099 182.164L764.04 112.017C756.787 109.297 753.16 107.937 749.429 107.398 746.12 106.92 742.757 106.92 739.449 107.398 735.717 107.937 732.09 109.297 724.837 112.017L537.779 182.164C511.662 191.958 498.603 196.855 488.978 205.336 480.477 212.828 473.93 222.278 469.898 232.869 465.338 244.857 465.338 258.803 465.338 286.697L465.338 418.655C465.338 574.292 655.823 687.072 722.063 721.583Z"
              stroke="currentColor"
              strokeWidth="23.2584"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeMiterlimit="4"
              strokeOpacity="1"
              fill="none"
              fillRule="nonzero"
              transform="matrix(1 0 0 1.01208 -83.0808 -62.514)"
            />
            <path
              d="M47.1373 252.184 47.1373 30.6392C47.1373 26.7342 50.3029 23.5686 54.2079 23.5686L191.513 23.5686C193.387 23.5686 195.186 24.3135 196.512 25.6396L233.616 62.7427C234.941 64.0687 235.686 65.8673 235.686 67.7424L235.686 252.184C235.686 256.089 232.521 259.255 228.616 259.255L54.2079 259.255C50.3029 259.255 47.1373 256.089 47.1373 252.184Z"
              stroke="currentColor"
              strokeWidth="23.2776"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeMiterlimit="4"
              strokeOpacity="1"
              fill="none"
              fillRule="nonzero"
              transform="matrix(1 0 0 1.01087 519.777 218.247)"
            />
            <path
              d="M188.549 63.6352 188.549 27.735C188.549 25.4339 190.414 23.5686 192.716 23.5686 193.82 23.5686 194.879 24.0075 195.662 24.7888L234.465 63.5935C235.247 64.3746 235.686 65.4344 235.686 66.5393 235.686 68.8405 233.82 70.7058 231.519 70.7058L195.619 70.7058C191.714 70.7058 188.549 67.5402 188.549 63.6352Z"
              stroke="currentColor"
              strokeWidth="23.2776"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeMiterlimit="4"
              strokeOpacity="1"
              fill="currentColor"
              fillRule="nonzero"
              fillOpacity="1"
              transform="matrix(1 0 0 1.01087 519.777 218.247)"
            />
          </g>
        </g>
      </g>
    </g>
  </Icon>
);
